<app-ion-common-label class="document-type-label1" 
  labelStyle="display-rg"
  [labelDescription]="title" [labelAria]="ariaTitle" [ariaLevel]="2">
</app-ion-common-label>
<div class="pd-align">
  <button type="button" class="mr-top" (click)="sendEventRetry.emit()">Tentar outra vez</button>
</div>